import { FC, useRef, useState } from "react";

import styles from "./navigation.module.less";
import { INavItemProps } from "./props";

export const NavItem: FC<INavItemProps> = (props) => {
  const { nav, active, onClick, onDropdownItemClick, activeDropdownKey } =
    props;

  const [showDropdown, setShowDropdown] = useState(false);

  const hideTimerRef = useRef<ReturnType<typeof setTimeout>>();

  const clearHideTimer = () => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = undefined;
    }
  };

  const handleClick = () => {
    onClick?.(nav);
  };

  const hasDropdown = nav.children && nav.children.length > 0;

  return (
    <span
      className={styles["nav-item"]}
      onClick={handleClick}
      onMouseEnter={() => {
        if (!hasDropdown) return;
        clearHideTimer();
        setShowDropdown(true);
      }}
      onMouseLeave={() => {
        if (!hasDropdown) return;
        clearHideTimer();
        hideTimerRef.current = setTimeout(() => setShowDropdown(false), 150);
      }}
    >
      {active ? nav.activeIcon : nav.icon}
      <b
        className={`${styles["nav-label"]} ${active ? styles["active"] : ""} ${
          nav.wrapWidth ? styles["nav-label-wrap"] : ""
        }`}
        style={nav.wrapWidth ? { maxWidth: nav.wrapWidth } : undefined}
      >
        {nav.label}
      </b>
      {hasDropdown && showDropdown && (
        <div className={styles["nav-dropdown"]}>
          {nav.children!.map((item) => {
            const isActive = activeDropdownKey === item.key;

            return (
              <div
                key={item.key}
                className={`${styles["nav-dropdown-item"]} ${
                  isActive ? styles["nav-dropdown-item-active"] : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  onDropdownItemClick?.(item);
                }}
              >
                <span
                  className={styles["nav-dropdown-indicator"]}
                  style={{ visibility: isActive ? "visible" : "hidden" }}
                >
                  |
                </span>
                <span>{item.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </span>
  );
};
